// extracted by mini-css-extract-plugin
export default {"home":"Home_home__IQrV+","sidebar":"Home_sidebar__4zih-","mainbody":"Home_mainbody__pf1MY"};